export const GradientAndShadowStyle = [
  {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    shadow: "0 8px 32px rgba(118, 75, 162, 0.5)",
  },
  {
    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    shadow: "0 8px 32px rgba(245, 87, 108, 0.5)",
  },
  {
    background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    shadow: "0 8px 32px rgba(0, 242, 254, 0.5)",
  },
  {
    background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    shadow: "0 8px 32px rgba(250, 112, 154, 0.5)",
  },
  {
    background: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)",
    shadow: "0 8px 32px rgba(161, 140, 209, 0.5)",
  },
  {
    background: "linear-gradient(135deg, #f4c610 0%, #fcb69f 100%)",
    shadow: "0 8px 32px rgba(252, 182, 159, 0.5)",
  },
];
